import { addDays, daysBetween, fm, weekStart } from './dates';

// Calendar weeks run Monday–Sunday in the client's local days. The week
// selector stays inside the fetched window and never passes today.

/** How many weeks the trend and the by-week heatmap show, at most. */
export const TREND_WEEKS = 12;

/** `iso` clamped to the fetched window [historyStart, today]. */
export const clampDay = (ctx, iso) => (iso < ctx.historyStart ? ctx.historyStart : iso > ctx.today ? ctx.today : iso);

/** "First logged week", "Week of Sep 7". */
export const weekName = (ctx, ws) => (ws === ctx.firstWeek ? 'First logged week' : `Week of ${fm(ws)}`);

/**
 * Trend / heatmap column label: "Week 3", counted from the first logged week
 * (Week 1), so a week keeps its number as the 12-week window moves. "Wk of
 * Sep 7" when nothing is logged yet.
 */
export const weekLabel = (ctx, ws) =>
  ctx.firstWeek && ws >= ctx.firstWeek ? `Week ${daysBetween(ctx.firstWeek, ws) / 7 + 1}` : `Wk of ${fm(ws)}`;

/**
 * The selected day moved a week back or forward, keeping its weekday (the
 * design's `setWeek`), clamped to the window; null when there is no such week.
 */
export function stepWeek(ctx, sel, dir) {
  const ws = addDays(weekStart(sel), 7 * dir);
  if (ws < ctx.minWeek || ws > ctx.maxWeek) return null;
  return clampDay(ctx, addDays(sel, 7 * dir));
}

/**
 * Up to 12 week starts ending at the selected week, starting no earlier than
 * the first logged week (nor the fetched window).
 */
export function trendWeeks(ctx, ws) {
  const floor = [ctx.firstWeek ?? ws, addDays(ws, -7 * (TREND_WEEKS - 1)), ctx.minWeek].sort().pop();
  if (floor > ws) return [ws];
  const n = daysBetween(floor, ws) / 7;
  return Array.from({ length: n + 1 }, (_, i) => addDays(floor, 7 * i));
}
